import { afterRenderEffect, Component, computed, signal, OnInit, inject, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Location } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

interface Idioma {
	codigo: string;
	nombre: string;
	bandera: string;
}

@Component({
	selector: 'cambio-idioma',
	standalone: true,
	imports: [FormsModule,MatSelectModule,MatFormFieldModule],
	templateUrl: './cambio-idioma.html',
	styleUrls: ['./cambio-idioma.scss']
})
export class CambioIdiomaComponent implements OnInit {
	private router: Router = inject(Router);
	private location: Location = inject(Location);

	// Signals para los idiomas disponibles
	private idiomasDisponibles = signal<Idioma[]>([
		// { codigo: 'ca', nombre: 'Català', bandera: '🇦🇩' },
		{ codigo: 'ca', nombre: 'Català', bandera: 'assets/imgs/cat.png'},
		{ codigo: 'en', nombre: 'English', bandera: '🇬🇧' },
		{ codigo: 'es', nombre: 'Español', bandera: '🇪🇸' },
	]);
	// Signal para el idioma actual
	private readonly locale_id = inject(LOCALE_ID);
	private idiomaActualSignal = signal<string>(this.locale_id);
	private idiomas_validos = this.idiomasDisponibles().map(idioma => idioma.codigo);

	// Computed que expone el idioma actual
	idiomaActual = computed(() => this.idiomaActualSignal());

	// Computed que expone los idiomas (por si se necesitan transformar)
	idiomas = computed(() => this.idiomasDisponibles());

	// Computed que indica si un idioma específico es el actual
	IdiomaActual = (codigo: string) => computed(() => this.idiomaActualSignal() === codigo);

	get idioma_actual() {
		return this.idiomaActualSignal();
	}
	set idioma_actual(value: string) {
		this.idiomaActualSignal.set(value);
	}
	// ==========================================================================
	// --------------------------------------------------------------------------
	constructor() { 
		// afterRender se ejecuta después de cada renderizado
		afterRenderEffect(() => {
			// Solo la primera vez
			// if (!this._inicializado) {
				this.detectarIdiomaActual();
				// this._inicializado = true;
			// }
		});
	}

	// --------------------------------------------------------------------------
	ngOnInit(): void {

		// this.detectarIdiomaActual();

	}

	// --------------------------------------------------------------------------
	// ✅ Método auxiliar para obtener la bandera
	getBandera(codigo: string): string {
		const idioma = this.idiomasDisponibles().find(i => i.codigo === codigo);
		return idioma?.bandera || '';
	}

	// --------------------------------------------------------------------------
	// ✅ Método auxiliar para obtener el nombre
	getNombreIdioma(codigo: string): string {
		const idioma = this.idiomasDisponibles().find(i => i.codigo === codigo);
		return idioma?.nombre || '';
	}
	// --------------------------------------------------------------------------
	private detectarIdiomaActual(): void {
		const urlActual = location.pathname;
		const match = urlActual.match(/\/(es|ca|en)\//);
		console.log('urlActual', urlActual);	

		if (match) {
			this.idiomaActualSignal.set(match[1]);
		} else {
			console.log('locale_id', this.locale_id);
			this.idiomaActualSignal.set(this.locale_id);
		}

	}

	// --------------------------------------------------------------------------
	cambiarIdioma(nuevoIdioma: any): void {

		// let valor_idioma = nuevoIdioma.target.value;
		console.log('valor_idioma', nuevoIdioma);
		let valor_idioma = nuevoIdioma;

		if (!this.idiomas_validos.includes(valor_idioma)) {
			valor_idioma = this.locale_id;
		}

		this.idiomaActualSignal.set(valor_idioma);

		const urlActual = location.href;
		let nuevaUrl = this.construirNuevaUrl(urlActual, valor_idioma);

		location.href = nuevaUrl;

	}

	// --------------------------------------------------------------------------
	// Método para construir la nueva URL con el idioma correcto
	private construirNuevaUrl(urlActual: string, nuevoIdioma: string): string {
		if (urlActual === '/' || urlActual === '') {
			return `/${nuevoIdioma}`;
		}

		if (urlActual.match(/\/(es|ca|en)\//)) {
			return urlActual.replace(/\/(es|ca|en)\/.+/, `/${nuevoIdioma}/`);
		}

		return `/${nuevoIdioma}${urlActual}`;

	}

	// --------------------------------------------------------------------------
	// Método para obtener la ruta actual sin el prefijo de idioma
	getRutaSinIdioma(): string {
		const urlActual = this.router.url;

		return urlActual.replace(/^\/(es|ca|en)/, '') || '/';

	}

}